import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import { Page, Document, View, Text, Image, pdf, Font } from "@react-pdf/renderer";
import logotipoLosAndes from "../../assets/LogotipoLosAndes.png";
import logotipoGA from "../../assets/LogotipoGA.png";
import config from "../../config.json";
import dayjs from "dayjs";
import 'dayjs/locale/es';
import { PDFDocument } from "pdf-lib";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

Font.register({
  family: 'Helvetica',
  src: '/path/to/Helvetica.ttf',
});

const s = {
  page: {
    width: "100%",
    paddingTop: 20,
    paddingBottom: 20,
    paddingRight: 20,
    paddingLeft: 40,
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  row: {
    flexDirection: "row",
  },
  col: {
    flexDirection: "column",
  },
  center: { textAlign: "center" },
  bold: { fontFamily: "Helvetica-Bold" },
  italic: { fontFamily: "Helvetica-Oblique" },
  border: { borderWidth: 1, borderColor: "#000" },
};

async function generatePDFBlob(MyDocComponent) {
  const blob = await pdf(<MyDocComponent />).toBlob();
  return blob;
}

// async function downloadPDFsFromLinks({ links, labelKey }) {
//   const blobs = await Promise.all(
//     links?.filter(x => x.strVal !== null && x.strVal !== "").map(async (item) => {
//       const url = item[labelKey];
//       const res = await fetch(url);
//       if (!res.ok) throw new Error(`Error al descargar ${item}`);
//       return await res.blob();
//     })
//   );
//   return blobs;
// }

async function mergePDFs(blobs) {
  const mergedPdf = await PDFDocument.create();
  for (const blob of blobs) {
    const arrayBuffer = await blob.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
    copiedPages.forEach(page => mergedPdf.addPage(page));
  }
  const mergedPdfBytes = await mergedPdf.save();
  return new Blob([mergedPdfBytes], { type: 'application/pdf' });
}

export const ExportTransferProcElementPDF = ({ procElement }) => {
  const { det_obs } = JSON.parse(procElement.details) ?? {};
  const { data, loading } = Request({
    urlApi: `/procElement/${procElement.id}/subElements`,
  });
  const [mergedBlob, setMergedBlob] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(true);

  const formatedData = data?.map(item => ({ ...item, ...(JSON.parse(item.details) ?? {}), company: procElement.companyName, internCode: item.internCode ?? '-',  stringNumber: item.stringNumber ?? '-' }));

  const MyDoc = () => {

    const RenderCustomTable = ({ columns, data }) => {
      let total = 0;
      const colWidths = procElement?.internCode
        ? [40, 90, 60, 60, 120, 140, 60, 60] 
        : [40, 60, 60, 90, 60, 60, 120, 140, 60, 60]

      return (
        <>
          <View style={[s.row, { borderBottomWidth: 1, borderColor: "#000", alignItems: "center", fontSize: 8 }]}>
            {columns.map((col, colIndex) => (
              <Text
                key={colIndex}
                style={[s.bold, { width: colWidths[colIndex], padding: 2, textAlign: "left", fontSize: 7 }]}
              >
                {col.label}
              </Text>
            ))}
          </View>
          {data.map((item, index) => {
            total += item.numVal ?? 0;
            return (
              <View key={index} style={[s.row, { alignItems: "center", fontSize: 7 }]}>
                {columns.map((col, colIndex) => (
                  <Text
                    key={colIndex}
                    style={{ width: colWidths[colIndex], padding: 2, textAlign: col.name === "amount" ? "right" : "left" }}
                  >
                    {col.name === "item" ? index + 1 : item[col.name] ?? '-'}
                  </Text>
                ))}
              </View>
            );
          })}
          <View style={[s.row, { borderTopWidth: 1, borderColor: "#000", marginTop: 5, fontSize: 8 }]}>
            {columns.map((col, colIndex) => (
              <Text
                key={colIndex}
                style={[s.bold, { width: colWidths[colIndex], padding: 2, textAlign: col.name === "numVal" ? "right" : "left" }]}
              >
                {colIndex === columns.length - 1 ? total : colIndex === columns.length - 2 ? "TOTAL" : ""}
              </Text>
            ))}
          </View>
        </>
      );
    };

    return (
      <Document>
        <Page size="A4" style={s.page}>
          <View style={[s.row, { justifyContent: "space-between", alignItems: "center" }]}>
            <Image src={config.isLosAndes ? logotipoLosAndes : logotipoGA} style={{ width: 150 }} />
            <View style={[s.col]}>
              <View style={[s.row, { fontSize: 10, gap: 2, justifyContent: "flex-end" }]}>
                <Text style={{ textAlign: 'right' }}>Nº</Text>
                <Text style={{ textAlign: 'right' }}>{procElement?.num ?? 0}</Text>
              </View>
              {procElement?.internCode && (
                <>
                  <View style={[s.row, { fontSize: 10, gap: 2, justifyContent: "flex-end" }]}>
                    <Text style={{ textAlign: 'right' }}>Interno</Text>
                    <Text style={{ textAlign: 'right' }}>{procElement.internCode}</Text>
                  </View>
                  <View style={[s.row, { fontSize: 10, gap: 2, justifyContent: "flex-end" }]}>
                    <Text style={{ textAlign: 'right' }}>Trámite</Text>
                    <Text style={{ textAlign: 'right' }}>{procElement.stringNumber ?? '-'}</Text>
                  </View>
                </>
              )}
            </View>
          </View>

          <View style={[s.col, { paddingTop: 10, paddingBottom: 5 }]}>
            <Text style={[s.center, s.bold, { fontSize: 13, paddingBottom: 10 }]}>
              SOLICITUD DE TRANSFERENCIAS - {procElement?.procedureTypeId === 1 ? 'IMPORTACIÓN' : 'EXPORTACION'}
            </Text>
            <View style={[s.row, { gap: 2, fontSize: 9 }]}>
              <Text style={[{ minWidth: 35 }]}>DE: </Text>
              <Text style={{ width: 250 }}>{config.isLosAndes ? 'LOS ANDES SRL. - SANTA CRUZ' : 'GAMARRA ANDES SRL. - LA PAZ'}</Text>
            </View>
            <View style={[s.row, { gap: 2, fontSize: 9 }]}>
              <Text style={[{ minWidth: 35 }]}>A: </Text>
              <Text style={{ width: 250 }}>MARIO GAMARRA A. - GERENTE GENERAL.</Text>
            </View>
            <View style={[s.row, { gap: 2, fontSize: 9 }]}>
              <Text style={[{ minWidth: 35 }]}>A c.c.: </Text>
              <Text style={{ width: 250 }}>DEPTO. CONTABILIDAD {config.isLosAndes ? 'SANTA CRUZ' : 'LA PAZ'}</Text>
            </View>
            <View style={[s.row, { gap: 2, fontSize: 9 }]}>
              <Text style={[{ minWidth: 35 }]}>FECHA: </Text>
              <Text style={{ width: 250 }}>{dayjs().locale('es').format('D [de] MMMM [de] YYYY')}</Text>
              <Text style={[s.bold]}>RETORNABLE</Text>
            </View>
          </View>

          <View style={[s.border, { fontSize: 8, marginBottom: 5 }]}>
            <RenderCustomTable
              columns={[
                { name: "item", label: "ITEM" },
                ...(procElement?.internCode == null ? [
                    { name: "stringNumber", label: "TRAMITE" },
                    { name: "internCode", label: "NRO. INTERNO" },
                  ] : []),
                { name: "company", label: "EMPRESA" },
                { name: "det_nroSolPlanilla", label: "NUMERO SOL/PLLA" },
                { name: "numVal", label: "IMPORTE Bs" },
                { name: "det_chequePara", label: "GIRAR CHEQUE PARA:" },
                { name: "det_concepto", label: "CONCEPTO DEL PAGO" },
                { name: "det_nroCheque", label: "Nº CH" },
                { name: "det_banco", label: "EMITENTE" },
              ]}
              data={formatedData || []}
            />
          </View>

          <View>
            <Text style={{ fontSize: 9 }}>OBSERVACIONES: {det_obs}</Text>
          </View>

          <View style={[s.row, s.italic, { opacity: 0.7, justifyContent: "space-evenly", paddingTop: 55 }]}>
            <View style={[s.col, { alignItems: "center" }]}>
              <Text>............................................</Text>
              <Text>Departamento de Contabilidad</Text>
              <Text>{config.isLosAndes ? 'Los Andes SRL SCZ' : 'Gamarra Andes SRL LPZ'}</Text>
            </View>
            <View style={[s.col, { alignItems: "center" }]}>
              <Text>............................................</Text>
              <Text>Gerente General</Text>
              <Text>{config.isLosAndes ? 'Los Andes' : 'Gamarra Andes'} SRL</Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  };

  useEffect(() => {
    setLoadingPDF(true);

    const preparePDF = async () => {
      try {
        if (!data || !formatedData) return;

        const generatedBlob = await generatePDFBlob(MyDoc);

        const downloadedBlobs = await Promise.all(
          formatedData
            .filter(item => item.strVal)
            .map(async (item) => {
              const url = item.strVal;
              const res = await fetch(url);
              if (!res.ok) throw new Error(`Error al descargar ${url}`);

              const contentType = res.headers.get("content-type");

              if (contentType.includes("pdf")) {
                return await res.blob();
              } else if (contentType.startsWith("image/")) {
                const imageBlob = await res.blob();
                const imageUrl = URL.createObjectURL(imageBlob);

                const TempDoc = () => (
                  <Document>
                    <Page size="A4" style={{ padding: 20 }}>
                      <Image src={imageUrl} style={{ width: "100%", objectFit: "contain" }} />
                    </Page>
                  </Document>
                );

                const pdfBlob = await generatePDFBlob(TempDoc);
                URL.revokeObjectURL(imageUrl);
                return pdfBlob;
              } else {
                console.warn("Tipo de archivo no soportado:", contentType);
                return null;
              }
            })
        );

        const finalBlobs = [generatedBlob, ...downloadedBlobs.filter(b => b)];

        const finalMerged = await mergePDFs(finalBlobs);
        setMergedBlob(finalMerged);
      } catch (error) {
        console.error("Error al preparar el PDF:", error);
      } finally {
        setLoadingPDF(false);
      }
    };
    preparePDF();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleDownloadPDFMerged = () => {
    if (!mergedBlob) return;
    const url = URL.createObjectURL(mergedBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `SolicitudTransferencia-${data?.numeroSolicitud || 'descarga'}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  };
  if (!loading) return <Circle />;

  return (
    <div className="grid place-content-center pb-4 min-w-[300px]">
      <button onClick={handleDownloadPDFMerged} className="flex items-center gap-1 md:gap-2 cursor-pointer group font-semibold text-[#4d74af] hover:text-[#3c5f94] hover:bg-[#618BCC]/20 rounded-md p-2">
        {loadingPDF ? (<FontAwesomeIcon icon="fas fa-spinner" className="animate-spin text-[30px]" />) : (
          <>
            <FontAwesomeIcon icon="fas fa-file-pdf" /> Descargar
          </>
        )}
      </button>
    </div>
  );
};
